<template>
  <div class="details" v-if="list">
    <h1>
      <!-- <el-popover v-if="list.CardCondition" placement="bottom" width="540" trigger="click">
        <div class="popoverCondition">
          <div>{{$t('categoryKey.veryGood')}}</div>
          <p v-html="$t('alert.popoverConditionVeryGood')"></p>
          <div>{{$t('categoryKey.good')}}</div>
          <p v-html="$t('alert.popoverConditionGood')"></p>
          <div>{{$t('categoryKey.poor')}}</div>
          <p v-html="$t('alert.popoverConditionPoor')"></p>
        </div>
        <span slot="reference" class="tag tag_condition el-icon-warning-outline">{{categoryI18n(list.CardCondition)}}</span>
      </el-popover> -->
      <span v-if="list.CardCondition" class="tag tag_condition el-icon-warning-outline" @click="$emit('setframe')">{{categoryI18n(list.CardCondition)}}</span>
      <span v-if="list.CardSize" class="tag tag_size">{{categoryI18n(list.CardSize)}}</span>
      {{list.Title}}
      <div><span :class="getCountDown(list.EffectiveTime)==1?'text_red':''">{{$t('colon.timeLeft')}}
          <em>{{CountDown(list.EffectiveTime,0)}}</em></span>{{list.EffectiveTime |setTime}}</div>
    </h1>
    <div class="price_btn_box line">
      <div class="price_list_box">
        <div class="price_list">
          <span class="price_default">{{$t('colon.CurrentBid')}}</span>
          <div class="price_us" :class="{'text_greed':(isbid==1),'text_red':(isbid==2)}" >{{areaSymbol}} {{list.USD_Price}}</div>
        </div>
        <el-alert v-if="userInfo!=null&&list.SellUserID==userInfo.MappingUserId" :title="$t('alert.buyYourItem')" type="error" show-icon :closable='false'></el-alert>
        <div class="price_list" v-if="userInfo!=null&&list.SellUserID!=userInfo.MappingUserId">
          <span class="price_name">{{$t('colon.binAmount')}}</span>
          <el-input class="detail_ipt" :placeholder="$tc('base.binAmount',place_price,{ n: areaSymbol+place_price })" type="text" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" v-model="place_input" @input="IsNumber()" />
        </div>
        <div class="price_list list_deposit" v-if="list.DepositNum>0">
          <div class="price_list_deposit">{{$t('colon.depositCHP')}} {{list.DepositNum}}</div>
          <!-- <div class="price_list_deposit">CHP waived limit: {{list.DepositNum}}</div> -->
          <!-- <div class="price_list_deposit">CHP waived limit: {{list.DepositNum}}</div> -->
          <!-- <span>{{list.CreditNum}} or more positive feedback will be free to bid</span> -->
          <!-- <span>CHP waived limit: {{list.CreditNum}}</span> -->
          <span v-if="list.CreditNum>0">{{$t('colon.feedbackCHP')}} {{list.CreditNum}} {{$t('base.orAbove')}}</span>
        </div>
      </div>
      <div class="detail_btn_box" v-if="userInfo!=null&&list.SellUserID!=userInfo.MappingUserId">
        <div class="bids_box">
          <!-- <span class="icon_auction">{{list.AuctionCount}} bids</span> -->
          <router-link class="auction_h icon_auction" :to="{path:'/mycardhobby/bidhistory/'+list.ID}" v-if="userInfo!=null&&list.AuctionCount>0">{{list.AuctionCount}} {{list.AuctionCount != 1?$t('base.bids'):$t('base.bid')}}</router-link>
          <span class="icon_auction auction_nh" v-else>{{list.AuctionCount}} {{list.AuctionCount != 1?$t('base.bids'):$t('base.bid')}}</span>
        </div>
        <!-- <div class="detail_btn primary" @click="getAuctionCheck" v-if="userInfo.Count>0&&userInfo.TelPhone&&userInfo.VerifyStatus!=2">{{$t('base.placeBid')}}</div> -->
        <div class="detail_btn primary" @click="isAddCout">{{$t('base.placeBid')}}</div>
        <div class="detail_btn">
          <div class="collec" :class="isWatchlist?'on':''" @mousemove="setwatch(isWatchlist,1)" @mouseout="setwatch(isWatchlist,0)" @click="setAttention">{{watchName}}</div>
        </div>
      </div>
      <div class="detail_btn_box" v-if="userInfo==null">
        <router-link class="detail_btn primary" :to="{path:'/login'}">{{$t('base.placeBid')}}</router-link>
        <router-link class="detail_btn" :to="{path:'/login'}">{{$t('base.addToWatch')}}</router-link>
      </div>
    </div>
    <!-- <div class="deposit text_gray small_text">
      Deposit Needed(CHP):{{list.integral}}CreditNum
    </div> -->
    <div class="line how_tb howRules">
      <router-link class="text_blue" :to="{path:'/terms/privacy?type=4'}" target="_blank">{{$t('symbol.bid')}}</router-link>
      <router-link class="text_blue" :to="{path:'/terms/privacy?type=4'}" target="_blank">{{$t('base.rulesOfBidding')}}</router-link>
    </div>
    <!-- 所在地 -->
    <div class="line how_tb address_from">
      <span class="ship" v-if="otherList&&otherList.address" :class="'earth icon_'+list.MemberSource">{{$t('base.shipsFrom')}} {{otherList.address}}</span>
      <span>{{attentionCount(list.AttentionCount)}}</span>
    </div>
    <!-- 運費 -->
    <div class="line watchers" v-if="domesticCustom">
      <div class="DomesticCustom">
        <span class="price_name">{{$t('colon.shipping')}}</span>
        <div>
          <div class="Shipping" v-if="domesticCustom">
            <span v-if="domesticCustom.Status==1">{{$t('base.freeShipping')}}</span>
            <span :class="list.MemberSource!='US'?'business':''" v-if="domesticCustom.Status==2">{{list.MemberSource!='US'?$t('alert.PaidOnDelivery'):$t('base.payOnDelivery')}}</span>
            <span v-if="domesticCustom.Status==3">{{areaSymbol}} {{domesticCustom.USD_Price}}</span>
          </div>
          <div class="hengxian"></div>
          <span class="text_blue see see_details" @click="domVisible=true" v-if="list.OrderType!=1&&list.MemberSource=='US'">{{$t('base.seeDetails')}}</span>
        </div>
      </div>
      <!-- <span class="text_blue see isUS" @click="IsUS">{{$t('base.ifSellerNoUSA')}}</span> -->
      <div class="text_gray" v-if="list.DomesticCustom.length>0">{{$t('colon.located')}} {{otherList.address}}</div>
    </div>
    <!-- 服務費 -->
    <div class="watchers" v-if="ServiceFee>0">
      <div class="Premium">
        <span class="price_name">{{$t('colon.buyerPremium')}} </span>
        <div>
          <span>{{areaSymbol}} {{ServiceFee}} {{SPercent}}</span>
          <!-- <span class="del" v-if="Discount>0">$ {{Discount}} {{DPercent}}</span> -->
        </div>
        <!-- <span class="Promotion">{{$t('base.promotion')}}</span> -->
        <div class="hengxian"></div>
        <span class="text_blue see see_details" @click="IsPremium(2)">{{$t('base.seeDetails')}}</span>
      </div>
    </div>
    <!-- 稅 -->
    <div class="watchers" v-if="userInfo!=null&&TaxServiceFee!=null&&list.MemberSource=='US'">
      <div class="Premium">
        <span class="price_name">{{$t('colon.stateTax')}} </span>
        <!-- <div class="tax_price">
          <span>$ {{TaxServiceFee}} {{TaxSPercent}}</span>
          <span>{{$t('base.accordToShipAddress')}}</span>
          <span class="tax_price_Promotion">
            <span class="Promotion">{{$t('base.promotion')}}</span>{{TaxSPercent}} {{$t('base.inPromotionPeriod')}}
          </span>
        </div> -->
        <div>
          <span>{{areaSymbol}} {{TaxServiceFee}} {{TaxSPercent}}</span>
          <!-- <span class="del" v-if="TaxDiscount>0">$ {{TaxDiscount}} {{TaxDPercent}}</span> -->
        </div>
        <!-- <span class="Promotion">Promotion</span> -->
        <div class="hengxian"></div>
        <span class="text_blue see see_details" @click="IsPremium(3)">{{$t('base.seeDetails')}}</span>
      </div>
      <div class="text_oversea" v-if="userInfo!=null&&(list.MemberSource!=userInfo.MemberSource&&userInfo.MemberSource!='MO')">{{$t('alert.willBeOversea')}}</div>
    </div>
    <!-- dialog -->
    <place-bid ref="refPlaceBid" v-if="dislogType.placebid" :Visible="dislogType.placebid" @getDialog="getDialog" :Auction='isAuction' :placeList="placeList" :time="placeList.EffectiveTime" />
    <domestic :domVisible="domVisible" :list="placeList" v-if="domVisible" @getDialog="SetDomDialog" />
    <get-change title="Add Phone Number" :domVisible='dislogType.changePhone' type="1" :userInfo="userInfo" @closeDialog="closeDialog" v-if='dislogType.changePhone' />
    <get-address v-if="dislogType.commodityaddress" :dialogVisible.sync="dislogType.commodityaddress" :isNew='true' @closeDialog="closeDialog" :userInfo.sync="userInfo" />

    <!-- dialog end -->
  </div>
</template>
<script>
import { countDown, getInfo, getTime, setUTC, addressList, isNumber, priceExchange, isNum, getBid, numCeil, numAdd, numMulti, isUserDomest } from "@/api/public";
import PlaceBid from "@/components/dialog/placebid";
import Domestic from "@/components/dialog/domestic";
import GetChange from "@/components/dialog/changePhone"; // 修改手机号或邮箱
import GetAddress from "@/components/dialog/commodityaddress"; // 收货地址

import qs from 'qs'
export default {
  name: 'auction',
  components: { PlaceBid, Domestic, GetChange, GetAddress},
  data() {
    return {
      agencyProvice: null,
      areaSymbol: this.$store.state.areaSymbol,
      domesticCustom: null,
      isWatchlist: this.list.IsAttention != 0 ? true : false,
      watchName: this.$t('base.addToWatch'),
      userInfo: null,
      isbid:0,
      input: "",
      dislogType: this.$enumInfo.dislogType,
      domVisible: false,
      dialogVisible: false,
      place_input: "", // 快捷输入竞拍价格
      place_price: 0, //快捷竞拍最低价
      timer: "",
      placeList: null,
      isAuction: false,
      nowData: new Date().getTime(),
      ServiceFee: null,
      Discount: null,
      SPercent: null,
      DPercent: null,
      TaxServiceFee: null,
      TaxDiscount: null,
      TaxSPercent: null,
      TaxDPercent: null,
      
    }
  },
  watch: {
    'list': {
      handler(obj) {
        console.log(obj,'watchlist')
        this.domesticCustom = isUserDomest(this.userInfo, this.list.DomesticCustom, this.agencyProvice)
        this.isPlacePrice()
        this.GetServiceFee();
        this.setPriceColor(obj);
      },
      deep: true
    }
  },
  props: {
    list: {},
    otherList:{}
  },
  filters: {
    //设置时间
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimess(val) {
      return getTime(val, 8, '', 'cn')
    },
    setTimes(val) {
      return getTime(val, -8, '', 'cn')
    },

  },
  mounted() {
    this.GetServiceFee();
  },
  created() {
    this.placeList = this.list
    if (this.isWatchlist) {
      this.watchName = this.$t('base.watching')
    }
    this.userInfo = getInfo()

    if (this.userInfo != null) {
      this.GetAgency(this.list)
      this.setPriceColor(this.list);
    }
    if (this.list) {
      this.isPlacePrice()
    }
    this.cardTimer();
  },
  methods: {
    categoryI18n(obj) {
      var value = obj.replace(/\s*/g, "")
      if (value.indexOf('/') > 0) {
        value = value.replace('/', "")
      }
      var i18nValue=this.$t('categoryKey.' + value)
      if(i18nValue.indexOf('categoryKey.')>-1){
        i18nValue=obj
      }
      return i18nValue
      //console.log(value,'value')
    },
    setPriceColor(obj){
      console.log(obj,'obj')
      let that=this
      that.isbid=0
      if(that.userInfo){
        let num=0
        let data=obj.Auctions
        data.map(r => {
                  if (r.CreateUser == that.userInfo.MappingUserId) {
                    num++;
                  }
                })
        if(num>0){
          if (data[0].CreateUser == that.userInfo.MappingUserId){
            that.isbid=1
          }else{
            that.isbid=2
          }
        }
      }
    },
    // 关闭并打开其他弹框
    openCloseDialog(openVal,closeVal,openBol,closeBol){

      this.dislogType[openVal] = openBol;
      this.dislogType[closeVal] = closeBol;
    },
    setShipsFrom(obj) {
      var that=this
      var address = obj.Address
      if(that.userInfo){
        if(that.userInfo.MemberSource!=obj.MemberSource){
               
        }
      }
      if (obj.MemberSource == 'CN') {
        address = 'China'
      }
      if (obj.MemberSource == 'HK') {
        address = 'Hong Kong'
      }
      if (obj.MemberSource == 'MO') {
        address = 'Macao'
      }
      if (obj.MemberSource == 'TW') {
        address = 'China TaiWan'
      }
      return address
    },
    GetAgency(obj) {
      let that = this
      if (obj.MemberSource != that.userInfo.MemberSource) {
        let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, memberSource: obj.MemberSource }
        this.$get(this.$interface.GetAgency, data).then(res => {
          if (res.result != 0) {
            that.agencyProvice = res.data
            that.domesticCustom = isUserDomest(that.userInfo, that.list.DomesticCustom, that.list.MemberSource, res.data)
          }
        })
      } else {
        this.domesticCustom = isUserDomest(that.userInfo, that.list.DomesticCustom, that.list.MemberSource, null)
      }
    },
    // 判断商品竞价是否有埋价
    isPlacePrice() {
      let that = this
      let price = isNumber(that.list.USD_Price)
      if (this.userInfo != null) {
        if (that.list.USD_HighestPrice != 0 && that.list.USD_HighestPrice > that.list.USD_Price) {
          price = isNumber(that.list.USD_HighestPrice)
        }
      }
      let num = getBid(price) // 获取阶梯价格
      let p1 = numCeil(numAdd(price, numMulti(num, 1))) //获取第一档的价格
      that.place_price = p1


      that.$nextTick(() => {
        that.$refs.refPlaceBid = that.$refs.refPlaceBid || ''
        if (that.$refs.refPlaceBid) {
          that.$refs.refPlaceBid.list = that.list;
        }
      });
    },
    // 竞拍数字判断
    IsNumber(e) {
      if (this.place_input.length >= 9) {
        this.place_input = this.place_input.slice(0, 9)
        // if(this.place_input.indexOf('.')>0){

        // }else{
        //   this.place_input=this.place_input.slice(0,9)
        // }
        //console.log(this.place_input,'that.place_input1231')
      }
    },
    // 获取快捷竞拍价格并出价
    setPlacePrice() {
      let that = this;
      let data = ""
    },
    // 用户来源对应服务费列表
    GetServiceList() {
      let that = this;
      let SellMemberSource = that.list.MemberSource
      let BuyMemberSource = that.userInfo.MemberSource
      let data = { buyerSource: BuyMemberSource, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
      // console.log(data, 'DPercent')
      that.$get(that.$interface.GetServiceList, data).then(res => {
        if (res.result != 0) {
          var result = res.data
          result.map(item => {

            var PayType = 'Stripe'
            if (BuyMemberSource == "MO") {
              PayType = 'MPay'
            }
            if (item.BuyerSource == BuyMemberSource && item.SellerSource == SellMemberSource && item.PayType == PayType) {
              //item.Fee * 100
              that.SPercent = item.Fee != 0 ? '(' + (numMulti(item.Fee, 100)) + '%)' : '(0%)'
              that.$root.$emit("SPercent", (numMulti(item.Fee, 100)));
              //(item.Discount * 100)
              that.DPercent = item.Discount != 0 ? '(' + (numMulti(item.Discount, 100)) + '%)' : '(0%)'
            }
          })
        }
      })
    },
    // 税
    GetTaxPrice() {
      let that = this;
      if (this.userInfo != null) {
        if (that.userInfo.Count > 0) {
          let data = { commodityId: this.list.ID, StateName: that.userInfo.State, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
          that.$get(that.$interface.GetTaxPrice, data).then(res => {
            if (res.result != 0) {
              that.TaxServiceFee = priceExchange(res.data.TaxPrice, 'USD')
              that.TaxDiscount = priceExchange(res.data.Discount, 'USD')
              //(res.data.TaxPercent * 100) (res.data.DiscountPercent * 100)
              that.TaxSPercent = res.data.TaxPercent != 0 ? '(' + (numMulti(res.data.TaxPercent, 100)) + '%)' : '(0%)'
              that.TaxDPercent = res.data.DiscountPercent != 0 ? '(' + (numMulti(res.data.DiscountPercent, 100)) + '%)' : '(0%)'
            }
          })
        }
      }
    },
    // 服务费
    GetServiceFee() {
      let that = this;
        //console.log(that.domesticCustom,'that.domesticCustom.Price')
      if (this.list && this.userInfo != null) {
        this.domesticCustom = isUserDomest(this.userInfo, this.list.DomesticCustom, this.list.MemberSource, this.agencyProvice)
        that.GetTaxPrice();
        that.GetServiceList()
        //var DomesticPrice = this.list.DomesticCustom[0].Price || 0
        var DomesticPrice=0
        try{
          DomesticPrice = that.domesticCustom.Price
        }catch(error){}
        let data = { memberId: this.userInfo.MappingUserId, commodityId: this.list.ID, postageMoney: DomesticPrice, isGuareent: 6, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
        that.$get(that.$interface.GetServiceFeeByCommodityID, data).then(res => {
          if (res.result != 0) {
            that.ServiceFee = priceExchange(res.data.ServiceFee, 'USD')
            that.Discount = priceExchange(res.data.Discount, 'USD')
          }
        })
      }
    },
    attentionCount(val) {
      let count = isNumber(val)
      if (count <= 1) {
        return count+" " + this.$t('base.watcher')
      } else {
        return count+" "  + this.$t('base.watchers')
      }
    },
    //mousemove/mouseout
    //关注类型
    setwatch(val, type) {
      let that = this
      let isWatch = val
      if (isWatch) {
        that.watchName = that.$t('base.watching')
        if (type) {
          that.watchName = that.$t('base.unWatch')
        }
      } else {
        that.watchName = that.$t('base.addToWatch')
      }
    },
    // 判断默认地址是否为空
    isAddCout() {
      let that = this
      that.userInfo = getInfo()
      if (that.userInfo.VerifyStatus == 2) {
        //已认证
        if (!that.userInfo.TelPhone) {
          that.isTelPhone()
        } else {

          if (that.userInfo.Count > 0) {
            that.getAuctionCheck()
          } else {
            that.$confirm(that.$t('alert.noAddress'), that.$t('base.somethingImportant'), {
              confirmButtonText: that.$t('base.goToSet'),
              cancelButtonText: that.$t('base.cancel'),
              lockScroll: false
            }).then(() => {
              that.dislogType['commodityaddress'] = true;
              //dislogType.commodityaddress
              // let url = this.$router.resolve({ path: '/mycardhobby/setting' })
              // window.open(url.href, '_blank');
            }).catch(() => {});
          }
        }
      }else{
        //未认证
        that.title = that.$t('kyc.IDVerification')
        that.dislogType['idverification'] = true;
      }
    },

    // 判断用户是否存在手机号
    isTelPhone() {
      this.dislogType['changePhone'] = true;
      // this.$confirm('Please set your Phone number!', 'Something Important', {
      //   confirmButtonText: 'Go to Set',
      //   cancelButtonText: 'Cancel',
      //   lockScroll: false
      // }).then(() => {
      //   let url = this.$router.resolve({ path: '/mycardhobby/setting' })
      //   window.open(url.href, '_blank');
      // }).catch(() => {
      //   // this.$message({
      //   //   type: 'info',
      //   //   message: '已取消删除'
      //   // });          
      // });
    },
    //竞拍资格校验
    getAuctionCheck() {
      let that = this
      this.placeList = this.list;
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID }
      this.$get(this.$interface.AuctionCheck, data).then(res => {
        if (res.result == 1) {
          if (this.place_input != null && this.place_input > 0) {
            that.placeList.newPlacePrice = that.place_input;
          }
          that.isAuction = true;
          that.dislogType.placebid = true;
        } else {
          if (this.place_input != null && this.place_input > 0) {
            that.placeList.newPlacePrice = that.place_input;
          }
          that.placeList.DepositNum = res.data.DepositNum;
          that.placeList.SumMoney = res.data.SumMoney;
          that.isAuction = false;
          that.dislogType.placebid = true;
        }
        // msg: '竞拍校验通过', result: 1
      })
    },
    // 弹框关闭
    getDialog(val, val1) {
      this.dislogType.placebid = val
      this.isAuction = false
      console.log(val, val1,'getDialog')
      this.$emit('updateDetail',val1)
    },
    // 关闭添加手机号弹框
    closeDialog(val, bol, type) {
      this.dislogType[val] = bol;
      if (type == 1) {
        this.userInfo = getInfo()
      }
      if (type == 'commodity') {
        this.userInfo = getInfo()
        this.$emit('updateDetail')
      }
    },
    // 一秒一次计时
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 获取倒计时
    CountDown(itemEnd, val) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      if (val == 0) {
        //拍卖结束
        if (countDown(i, newval) == "00:00") {
          this.$emit('acution')
        }
      }
      //console.log(itemEnd)
      return countDown(i, newval)
    },
    getCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(i, newval, 0)
    },
    // 关注商品
    setAttention() {
      let that = this;
      if (that.userInfo != null) {
        let data = { 'commodityid': that.list.ID, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        this.$post(that.$interface.SetAttention, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            that.isWatchlist = !that.isWatchlist

            that.watchName = that.$t('base.addToWatch')
            if (that.isWatchlist) {
              that.watchName = that.$t('base.watching')
            }
          }
        })
      }
    },
    SetDomDialog(val) {
      this.domVisible = val
    },
    IsUS() {
      this.$emit('isus')
    },
    IsPremium(val) {
      this.$emit('ispremium', val)
    }
  },
  destroyed() {
    //清除倒计时
    clearInterval(this.timer);
  }
}

</script>
<style scoped>
@import "../../../static/css/carddetails.css";

h1 {
  margin-bottom: 16px;
}

.deposit {
  padding-left: 100px;
}

.address_from span {
  display: block;
}

.address_from span:first-child {
  margin-bottom: 16px;
}

.address_from span.earth {
  background: url(/static/images/icon/icon_earth.svg) no-repeat;
  padding-left: 23px;
}

.how_tb {
  padding-bottom: 16px;
}

.text_gray {
  margin-top: 10px;
}

.price_list_deposit {
  margin-top: 8px;
}

.list_deposit {
  flex-direction: column;
}

.list_deposit span {
  color: #999;
}

</style>



// WEBPACK FOOTER //
// src/components/detail/auction.vue